import React from 'react'

export const Unauthorized = () => {
  return (
    <div>You are unauthorized!</div>
  )
}
